import React from 'react';
import './Footer.css';
import profileImage from '../assets/image/about/ckFormal.png'; // replace with correct path
import { FaWhatsapp, FaInstagram, FaTiktok, FaGlobe } from 'react-icons/fa';
import { InstagramOutlined, FacebookFilled, MenuOutlined, CloseOutlined,TikTokOutlined, LinkedinOutlined} from '@ant-design/icons';
import { BiFontSize } from 'react-icons/bi';

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <div className="footer-main">
        <div className="footer-left">
          <img src={profileImage} alt="Calvin Heng" className="footer-img" />
          <div className="footer-caption">
            <p ><p className ="footer-name">Calvin Heng</p><p  >Solution Architect</p></p>
          </div>
        </div>

        <div className="footer-right">
          <h2 className="footer-name">Calvin HENG</h2>
          <p className="footer-tagline">Solution Architect</p>

        <div className="footer-links">
          
 <a href="https://instagram.com/hengchengkiat" target="_blank" rel="noreferrer">
    <InstagramOutlined className="footer-icon" />
  </a>
<a href="https://www.linkedin.com/in/heng-cheng-kiat-63bb7b162/" target="_blank" rel="noreferrer">
    <LinkedinOutlined className="footer-icon" />
  </a>
</div>

<div className="footer-buttons">
  <a href="https://wa.me/6596432836" target="_blank" rel="noreferrer">
    <button className="footer-btn">
      <FaWhatsapp className="footer-icon" /> WhatsApp
    </button>
  </a>
  <a href="tel:+6596432836">
    <button className="footer-btn">
      📞 Give a Call
    </button>
  </a>
</div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
